module.exports = __webpack_public_path__ + "static/media/M003-noprivilege.04bdbe28.svg";